import { ArrowRight, MessageCircle, ShieldCheck, Wifi, Cpu, Cable } from "lucide-react";
import { SITE } from "../../lib/site";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/45876ead-02aa-42fd-bdbd-b2c7f606006c/images/5e89d2edf7208b7bfd5632615927a75b0f83131552265289358677ccd436df72.png";

export const Hero = () => {
  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative overflow-hidden pt-32 md:pt-40 pb-24 md:pb-32"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
        aria-hidden
      />
      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-[#050505]" aria-hidden />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent" aria-hidden />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(76,46,155,0.35),transparent_60%)]" aria-hidden />
      <div className="nx-blob bg-[#4c2e9b] w-[520px] h-[520px] -top-32 -left-24" aria-hidden />
      <div className="nx-blob bg-[#00f0ff]/40 w-[380px] h-[380px] bottom-0 right-0" aria-hidden />

      <div className="relative max-w-7xl mx-auto px-6 md:px-8">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 backdrop-blur-md">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" />
            <span className="overline text-white/80">Ecossistema de tecnologia · Grupo Nexus</span>
          </div>

          <h1 className="font-display mt-7 text-[40px] leading-[1.02] sm:text-5xl md:text-6xl lg:text-[76px] font-light tracking-tight text-white">
            Tecnologia que{" "}
            <span className="nx-rainbow-text font-medium">conecta</span>,{" "}
            <span className="text-white/90 font-medium">protege</span> e estrutura{" "}
            <span className="italic font-light text-white/90">o futuro.</span>
          </h1>

          <p className="mt-7 max-w-2xl text-base md:text-lg text-[#b3b0c2] leading-relaxed">
            O Grupo Nexus integra <strong className="text-white font-medium">conectividade</strong>,{" "}
            <strong className="text-white font-medium">monitoramento</strong>,{" "}
            <strong className="text-white font-medium">infraestrutura</strong> e{" "}
            <strong className="text-white font-medium">inovação digital</strong> em soluções completas
            para residências, condomínios e empresas.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <a
              href="#solucoes"
              data-testid="hero-cta-solutions"
              className="nx-btn-primary"
            >
              Conhecer soluções <ArrowRight size={16} />
            </a>
            <a
              href={SITE.whatsappUrl}
              target="_blank"
              rel="noreferrer noopener"
              data-testid="hero-cta-whatsapp"
              className="nx-btn-secondary"
            >
              <MessageCircle size={16} className="text-emerald-300" />
              Falar no WhatsApp
            </a>
          </div>

          {/* Pillar chips */}
          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-3 max-w-3xl">
            {[
              { icon: Wifi, label: "Fibra óptica" },
              { icon: ShieldCheck, label: "Monitoramento" },
              { icon: Cable, label: "Infraestrutura" },
              { icon: Cpu, label: "Inovação digital" },
            ].map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.03] backdrop-blur px-4 py-3"
              >
                <div className="h-8 w-8 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center">
                  <Icon size={16} className="text-white/80" strokeWidth={1.6} />
                </div>
                <span className="text-sm text-white/80">{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="nx-hairline absolute bottom-0 left-0 right-0" />
    </section>
  );
};

export default Hero;
